import {
    Button,
    Flex,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Heading,
    Input,
    Checkbox,
    Tag,
    Select,
    Textarea,
    extendTheme,
    ChakraProvider,
    Box
} from '@chakra-ui/react';
import { Field, Form, Formik } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import LoadingSpinner from '../../components/LoadingSpinner';
import { FocusError } from '../../components/FocusError';
import SemRegistros from '../../components/SemRegistros';
import { useAuthProvider } from '../../../Context/AuthProvider';
import { motivoFunc } from '../../../helpers/Funcionalidades'
import { Group } from '../Criancas/Group';

import MotivoSituacaoService from "../../../main/services/MotivoSituacaoService";

const EditarMotivoSituacao = (props) => {

    document.title = 'MCA - Motivo de Situação - Editar'
    let history = useHistory()

    const { roleKeycloack } = useAuthProvider();
    const _IsMounted = useRef(false);
    //const [isUpdating, setIsUpdating] = useState(props.match.params.editar ? true : false)
    const [descricaoCount, setDescricaoCount] = useState(0);
    const [conceitoCount, setConceitoCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [motivoSituacao, setMotivoSituacao] = useState({
        descricao: "",
        tipoSituacaoId: "",
        riscoVida: [],
        extincaoPoderFamiliar: [],
        conceito: "",
    });

    const theme = extendTheme({
        components: {
            Checkbox: {
                baseStyle: {
                    control: {
                        bg: "#FFF",
                        _checked: {
                            bg: "rgb(49, 130, 206)"
                        }
                    }
                }
            }
        }
    });

    useEffect(() => {

        _IsMounted.current = true;
        fetchData();
        return () => {
            _IsMounted.current = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    function fetchData() {
        MotivoSituacaoService.getMotivoSituacao(props.match.params.id)
            .then(res => {
                const {
                    riscoVida,
                    tipoSituacao,
                    tipoSituacaoId,
                    extincaoPoderFamiliar,
                    ...resto
                } = res?.data;
                setMotivoSituacao({
                    riscoVida: riscoVida === "S" ? ["Possui"] : [],
                    extincaoPoderFamiliar: extincaoPoderFamiliar === "S" ? ["Possui"] : [],
                    tipoSituacaoId:
                        tipoSituacao.id === 1 ? "1" :
                            tipoSituacao.id === 2 ? "2" : "",
                    ...resto
                });
                setDescricaoCount(res?.data?.descricao?.length);
                setConceitoCount(res?.data?.conceito?.length);

                if (res.data.existeMovimentacao) {
                    Swal.fire({
                        title: "Atenção!",
                        'text': "Motivo de Acolhimento em utilização no acolhimento de criança/adolescente.",
                        icon: 'warning',
                        confirmButtonText: 'Fechar',
                        confirmButtonColor: '#169499'
                    }).then(() => {
                    })
                }

                if (!!res.data.dataFim) {
                    Swal.fire({
                        title: 'Erro!',
                        'text': "Você não pode alterar um registro inativo!",
                        icon: 'error',
                        confirmButtonText: 'Fechar',
                        confirmButtonColor: '#169499'
                    }).then(() => {
                        history.push("/motivo-situacao/lista")
                    })
                }
                setLoading(false);

            }).catch((err) => {
                Swal.fire({
                    title: 'Atenção!',
                    'text': "Registro não encontrado",
                    icon: 'warning',
                    confirmButtonText: 'Fechar',
                    confirmButtonColor: "#169499"
                }).then(() => {
                    history.push("/motivo-situacao/lista")
                })
            })
    }

    const validate = (values) => {
        const errors = {};

        if (!values.tipoSituacaoId || values.tipoSituacaoId === "" || values.tipoSituacaoId.trim() === "") {
            errors.tipoSituacaoId = "Tipo de motivo de situação é obrigatório!";
        }

        if (!values.descricao || values.descricao === "" || values.descricao.trim() === "") {
            errors.descricao = "Descrição é obrigatória!";
        }

        if (!values.conceito || values.conceito === "") {
            errors.conceito = "Conceito é obrigatório!";
        }

        return errors;
    };

    return roleKeycloack && roleKeycloack.includes(motivoFunc.motivoEditar) ? (
        !loading
            ?
            <Flex
                pt={"20px"}
                px={["5px", "30px"]}
                h="100%"
                flexDir="column"
                w="100%"
                maxW="2000px"
                overflow="auto"
                pb={["10px", "20px"]}
            >
                <Flex
                    flexDir="row"
                    justifyContent="space-between"
                >

                    <Heading fontSize={'large'}>
                        Editar Motivo de Situação
                    </Heading>
                    <Button onClick={history.goBack} colorScheme={"teal"} px={16}>
                        Voltar
                    </Button>
                </Flex>
                <Flex>

                    <Formik
                        validate={validate}
                        validateOnChange={false}
                        validateOnBlur={false}
                        enableReinitialize
                        initialValues={motivoSituacao}
                        onSubmit={(values, actions) => {
                            const {
                                descricao,
                                riscoVida,
                                tipoSituacaoId,
                                conceito,
                                extincaoPoderFamiliar
                            } = values;

                            const valuesToSend = {
                                conceito,
                                motivoSituacao: descricao,
                                riscoVida:
                                    riscoVida.includes("Possui")
                                        ?
                                        "S"
                                        :
                                        "N"
                                ,
                                extincaoPoderFamiliar: extincaoPoderFamiliar.includes("Possui") ? "S" : "N",
                                tipoSituacaoId:
                                    tipoSituacaoId === "1" ? 1 :
                                        tipoSituacaoId === "2" ? 2 : "",
                            }

                            MotivoSituacaoService.atualizarMotivoSituacao(motivoSituacao.id, valuesToSend)
                                .then((res) => {
                                    Swal.fire({
                                        title: 'Sucesso!',
                                        'text': 'Registro atualizado com sucesso!',
                                        icon: 'success',
                                        confirmButtonText: 'Continuar',
                                        confirmButtonColor: '#169499'
                                    }).then(function () {
                                        actions.setSubmitting(false);
                                        history.push("/motivo-situacao/" + res.data.id);

                                    });
                                    actions.setSubmitting(false);
                                    //setIsUpdating(false)
                                }).catch((error) => {
                                    actions.setFieldError(error.response && error.response.data.field, error.response && error.response.data.message)
                                    actions.setSubmitting(false);
                                })
                        }}>
                        {(props) => (
                            <Flex
                                flexDir="column"
                                mt="40px"
                                w="100%">
                                <Form>
                                    <FocusError />
                                    <Flex flexDir="column">
                                        <Group bgColor="#fff" title="" py="12px" >
                                            <Box width={{ lg: '50%' }}>
                                                <Field name="tipoSituacaoId">
                                                    {({ field, form }) => (
                                                        <Flex flexDir="column">
                                                            <FormControl isInvalid={form.errors.tipoSituacaoId && form.touched.tipoSituacaoId}>
                                                                <FormLabel htmlFor="tipoSituacaoId">Tipo de Motivo de Situação*</FormLabel>
                                                                <Select
                                                                    backgroundColor={"white"}
                                                                    id="tipoSituacaoId"
                                                                    {...field}
                                                                    placeholder={"Selecione o Tipo de Motivo de Situação"}
                                                                    h="42px"
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        form.setFieldValue(field.name, value);

                                                                        if (value === "2") {
                                                                            form.setFieldValue("riscoVida", []);
                                                                            form.setFieldValue("extincaoPoderFamiliar", [])
                                                                        }
                                                                    }}
                                                                >
                                                                    <option value={"1"}>Acolhido</option>
                                                                    <option value={"2"}>Desligado</option>

                                                                </Select>
                                                                <FormErrorMessage>{form.errors.tipoSituacaoId}</FormErrorMessage>
                                                            </FormControl>
                                                        </Flex>
                                                    )}
                                                </Field>
                                                <Field name="descricao">
                                                    {({ field, form }) => (
                                                        <Flex flexDir="column" mt={5}>
                                                            <FormControl
                                                                isInvalid={form.errors.descricao && form.touched.descricao}>
                                                                <FormLabel htmlFor="descricao">Descrição*</FormLabel>
                                                                <Input
                                                                    autoFocus
                                                                    backgroundColor={"white"}
                                                                    id="descricao"
                                                                    {...field}
                                                                    placeholder="Informe a Descrição do Motivo de Situação"
                                                                    maxLength={255}
                                                                    onChange={(e) => {
                                                                        setDescricaoCount(e.target.value.length);
                                                                        form.setFieldValue(field.name, e.target.value);
                                                                    }}
                                                                    h="42px"
                                                                />
                                                                <FormErrorMessage>{form.errors.descricao}</FormErrorMessage>
                                                            </FormControl>
                                                        </Flex>
                                                    )}
                                                </Field>
                                                <Flex flexDirection="row-reverse">
                                                    <Tag maxW="max-content">{`${descricaoCount}/255`}</Tag>
                                                </Flex>
                                                <Flex flexDirection="column">
                                                    <Field name="riscoVida">
                                                        {({ field, form }) => (
                                                            <FormControl
                                                                id="riscoVida"
                                                                width="max-content"
                                                            >
                                                                <ChakraProvider theme={theme}>
                                                                    <Checkbox
                                                                        {...field}
                                                                        value="Possui"
                                                                        name="riscoVida"
                                                                        id="riscoVida"
                                                                        whiteSpace="nowrap"
                                                                        isChecked={props.values.riscoVida.includes("Possui") ? true : false}
                                                                        onChange={(e) => {
                                                                            form.setFieldValue(
                                                                                field.name,
                                                                                e.target.checked ? "Possui" : ""
                                                                            );
                                                                        }}
                                                                        disabled={props.values.tipoSituacaoId === "2" || motivoSituacao?.existeMovimentacao
                                                                        }
                                                                    >
                                                                        Risco de Vida
                                                                    </Checkbox>
                                                                </ChakraProvider>
                                                                <FormErrorMessage>{form.errors.riscoVida}</FormErrorMessage>
                                                            </FormControl>
                                                        )}
                                                    </Field>
                                                    <Field name="extincaoPoderFamiliar">
                                                        {({ field, form }) => (
                                                            <FormControl
                                                                id="extincaoPoderFamiliar"
                                                                width="max-content"
                                                            >
                                                                <ChakraProvider theme={theme}>
                                                                    <Checkbox
                                                                        {...field}
                                                                        value="Possui"
                                                                        name="extincaoPoderFamiliar"
                                                                        id="extincaoPoderFamiliar"
                                                                        whiteSpace="nowrap"
                                                                        isChecked={props.values.extincaoPoderFamiliar.includes("Possui") ? true : false}
                                                                        onChange={(e) => {
                                                                            form.setFieldValue(
                                                                                field.name,
                                                                                e.target.checked ? "Possui" : ""
                                                                            );
                                                                        }}
                                                                        disabled={props.values.tipoSituacaoId === "2" || motivoSituacao?.existeMovimentacao}
                                                                    >
                                                                        Houve Extinção do Poder Familiar?
                                                                    </Checkbox>
                                                                </ChakraProvider>
                                                                <FormErrorMessage>{form.errors.extincaoPoderFamiliar}</FormErrorMessage>
                                                            </FormControl>
                                                        )}
                                                    </Field>
                                                </Flex>
                                                <Field name="conceito">
                                                    {({ field, form }) => (
                                                        <Flex flexDir="column" mt={5}>
                                                            <FormControl
                                                                isInvalid={form.errors.conceito && form.touched.conceito}>
                                                                <FormLabel htmlFor="conceito">Conceito*</FormLabel>
                                                                <Textarea
                                                                    backgroundColor={"white"}
                                                                    id="conceito"
                                                                    {...field}
                                                                    placeholder=""
                                                                    maxLength={4000}
                                                                    onChange={(e) => {
                                                                        setConceitoCount(e.target.value.length);
                                                                        form.setFieldValue(field.name, e.target.value);
                                                                    }}
                                                                />
                                                                <FormErrorMessage>{form.errors.conceito}</FormErrorMessage>
                                                            </FormControl>
                                                        </Flex>
                                                    )}
                                                </Field>
                                                <Flex flexDirection="row-reverse">
                                                    <Tag maxW="max-content">{`${conceitoCount}/4000`}</Tag>
                                                </Flex>
                                            </Box>
                                        </Group>
                                        <Flex mt={2} justifyContent="space-between">
                                            <Flex></Flex>
                                            <Flex flexDir="row">
                                                <Button
                                                    mt={4}
                                                    mr={2}
                                                    colorScheme="teal"
                                                    px={14}
                                                    isLoading={props.isSubmitting}
                                                    type="submit"
                                                    translate="no">
                                                    Salvar
                                                </Button>
                                            </Flex>
                                        </Flex>

                                    </Flex>
                                </Form>

                            </Flex>
                        )}
                    </Formik>
                </Flex>
            </Flex>
            :
            <Flex
                w="100%"
                mt="25%"
                justifyContent="center"
            >
                <LoadingSpinner />
            </Flex>
    ) : (
        <Box mt={2}>
            <SemRegistros buttonVisible={true} half />
        </Box>
    );
}
export default EditarMotivoSituacao;